import React from 'react';
import { FadeIn } from './FadeIn';
import { Button } from './Button';
export function Hero() {
  return <section className="bg-teal text-white py-20 px-6 md:py-32 relative overflow-hidden" data-id="element-102">
      {/* Soft background shape for texture */}
      <div className="absolute top-0 right-0 w-full h-full opacity-10 pointer-events-none" data-id="element-103">
        <div className="absolute -top-[20%] -right-[10%] w-[70%] h-[100%] rounded-full bg-sage blur-3xl" data-id="element-104"></div>
      </div>

      <div className="max-w-6xl mx-auto grid md:grid-cols-2 gap-12 items-center relative z-10" data-id="element-105">
        <FadeIn data-id="element-106">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight mb-6" data-id="element-107">
            The 7-Day Menopause Inflammation Reset
          </h1>
          <p className="text-xl md:text-2xl text-cream/90 mb-10 font-light leading-relaxed" data-id="element-108">
            Cool the "Internal Fire," soothe your joints, and reclaim your sleep
            in just one week—without hormone drugs or expensive clinics.
          </p>
          <Button onClick={() => document.getElementById('offer')?.scrollIntoView({
          behavior: 'smooth'
        })} data-id="element-109">
            GET THE 7-DAY RESET NOW
          </Button>
        </FadeIn>

        <FadeIn delay={0.2} className="relative flex justify-center" data-id="element-110">
          <div className="relative w-full max-w-md" data-id="element-111">
            <div className="absolute inset-0 bg-sage/20 rounded-3xl blur-2xl transform -rotate-6" data-id="element-112"></div>
            <img src="https://cdn.magicpatterns.com/uploads/5dYGS5aihdLzGB2EWmwR58/heylloyd-image-1775149974649.png" alt="The 7-Day Menopause Reset Digital Guide on a tablet" className="relative z-10 rounded-xl shadow-2xl w-full object-cover" data-id="element-113" />
          </div>
        </FadeIn>
      </div>
    </section>;
}